
// 鼠标提示控件
import './mouse-tips/MouseTips.js';
import './mouse-tips/MouseTips.css';
import deleteIconUrl from '@/assets/images/deleteIcon.png'
import L from 'leaflet';

export class distanceMeasure {
    constructor(options) {
        this._map = options.map;
        this._mouseTips = L.control.mouseTips({
            show: true,
            message: '鼠标单击左键加点，双击结束'
        });

        this._deleteIcon = L.icon({
            iconUrl: deleteIconUrl,
            iconSize: [14, 14], // 图标大小
            iconAnchor: [7, 7], // 图标偏移量，否则无法居住显示
        });
        this._points = [];
        this._color = "red";
        this._layers = L.layerGroup();
        this._polyline = null;
        this._polylineGroup = [];
        this._marker = null;
        this._markerGroup = [];
    }

    init() {
        this._mouseTips.addTo(this._map).show();
        this._points = [];
        this._polyline = null;
        this._marker = null;

        let that = this;
        let click = function (e) { // 单击
            that._map.doubleClickZoom.disable();
            // 添加点信息
            that._points.push(e.latlng);
            // 添加线
            that._map.on('mousemove', mousemove);
        }
        let mousemove = function (e) { // 鼠标移动
            that._points.push(e.latlng);
            if (that._polyline)
                that._map.removeLayer(that._polyline);
            that._polyline = L.polyline(that._points, { showMeasurements: true, color: that._color });
            that._polyline.addTo(that._layers);
            that._layers.addTo(that._map);
            that._points.pop();
        }
        let dblclick = function (e) { // 双击结束
            // 移除鼠标绘制提示
            that._mouseTips.hide()
            that._polyline.addTo(that._layers);
            that._polylineGroup.push(that._polyline);
            that.close(e.latlng);
            that._map.off('click', click).off('mousemove', mousemove).off('dblclick', dblclick);
        }
        this._map.on('click', click).on('dblclick', dblclick);
    }
    close(latlng) {
        let that = this;
        this._marker = L.marker(latlng, { icon: this._deleteIcon }).addTo(this._map).on("click", function (e) {
            that.destory();
            // if (that._polyline)
            //     that._map.removeLayer(that._polyline);

            // if (that._marker)
            //     that._marker.remove();
        });
        this._markerGroup.push(this._marker);
    }
    destory() {
        if (this._polyline) {
            // this._map.removeLayer(this._polyline);
            this._polylineGroup.forEach(element => {
                this._map.removeLayer(element);
            });
        }

        if (this._marker) {
            // this._marker.remove();
            this._markerGroup.forEach(element => {
                element.remove()
            })
        }
        // 鼠标绘制提示
        this._mouseTips.addTo(this._map).hide();
    }
}

